import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { L10nLocale, L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [NgStyle, MatIconModule, MatButtonModule, L10nTranslatePipe],
})
export class ErrorMessageComponent {
  locale = inject<L10nLocale>(L10N_LOCALE);

  @Input() error: string;
  @Input() width?: string;
  @Output() retryClicked: EventEmitter<void> = new EventEmitter();

  onRetry() {
    this.retryClicked.emit();
  }
}
